// Solo modificar esta variable usando el script de deploy o dev
const deploy :number = 1;


if (deploy === 1) {
    var API_BASE_URL = 'https://www.emilianojan.com.ar/ls/php';
    var GOOGLE_CLIENT_ID = '984078845735-ph1efvra1j32km0t258rkvd88bk7bjem.apps.googleusercontent.com';
    var DEBUG_LAYOUT = false;
} else {
    var API_BASE_URL = 'http://localhost';
    var GOOGLE_CLIENT_ID = '984078845735-ss8htsgis2gn02bmmvcl11a2n9ufgpai.apps.googleusercontent.com';
    var DEBUG_LAYOUT = true;
};

export default {
    API_BASE_URL,
    GOOGLE_CLIENT_ID,
    DEBUG_LAYOUT,
};